import { useState, useEffect, useRef } from 'react';
import './CheckboxSelect.css';

interface CheckboxOption {
  id: string;
  name: string;
}

interface CheckboxSelectProps {
  options: CheckboxOption[];
  selectedOptions?: string[];
  onChange: (selected: string[]) => void;
  isLoading?: boolean;
}

const CheckboxSelect = ({
  options,
  selectedOptions = [],
  onChange,
  isLoading = false,
}: CheckboxSelectProps) => {
  const [_isOpen, setIsOpen] = useState(true);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionChange = (option) => {
    const newSelected = selectedOptions.includes(option.id)
      ? selectedOptions.filter((id) => id !== option.id)
      : [...selectedOptions, option.id];

    onChange(newSelected);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }
  return (
    <div className="checkbox-select" ref={dropdownRef}>
      <div className="options-container">
        {options.map((option) => (
          <label key={option.id} className="option">
            <input
              type="checkbox"
              checked={selectedOptions.includes(option.id)}
              onChange={() => handleOptionChange(option)}
            />
            {option.name}
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxSelect;
